import { Box, Chip, useTheme } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import React from 'react';
import { PAYMENT_STATUS } from '../../../constant/invoice';

const PaymentStatus = ({ status }) => {
  const t = useTranslate();
  const theme = useTheme();
  return (
    <Box
      component={Chip}
      sx={{
        "&[class*='Chip']": {
          padding: '3px 12px',
          backgroundColor: {
            [PAYMENT_STATUS.PAID]: theme.palette.success.main,
            [PAYMENT_STATUS.FAILED]: theme.palette.error.main,
            [PAYMENT_STATUS.PROCESSING]: theme.palette.primary.main,
            [PAYMENT_STATUS.WAIVED]: theme.palette.tertiary.main,
            [PAYMENT_STATUS.CANCELED]: theme.palette.grey[700],
            [PAYMENT_STATUS.UNPAID]: theme.palette.error.dark,
          }[status],
          color: 'white',
          '& span': {
            padding: '0 !important', // To override default styles
          },
        },
      }}
      label={t(`common.paymentStatus.${status}`)}
    />
  );
};

export default PaymentStatus;
